import { useState } from "react";
import { Restore } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";
import { observer } from "mobx-react-lite";

import RestoreDataDialog from "../../restore/RestoreDataDialog";

export default observer(function RestoreButton({ disabled }: { disabled?: boolean }) {
  const { themeClass } = useThemeService();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        id="restore"
        onClick={() => setOpen(true)}
        disabled={disabled}
        icon={{
          svg: Restore,
          textKey: "restoreEsicData.button.run",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-mui"]),
        }}
      />
      <RestoreDataDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
});
